<template>
  <img alt="TOWNSIO" src="./assets/townsio-large.png" class="center-asset">
  <TownsioIntro msg="Making the web work for people in towns"/>
</template>

<script>
import TownsioIntro from './components/TownsioIntro.vue'

export default {
  name: 'App',
  components: {
    TownsioIntro
  }
}
</script>

<style>
body {
  background-color: black;
}
.center-asset {
  width:50%;
  height:auto;
}
#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #68ec57;
  margin-top: 20%;
  background-color: black;
}
</style>
